import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Badge } from "../../../Assets/Images/badge.svg";
import {
  getPaymentMode,
  getUserDetail,
  getCity,
  getState,
  getUserType,
  saveUserData,
  getPincodeCheck,
  checkRedeemValue,
  getTermsConditions

} from '../../../Services/action.js';

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { regex } from '../../../utils/constants';
import AppTracking from '../../../Components/appTracking.js';
import { DataContext } from '../../../Components/DataContext.js';




const Dashboard = () => {

  const navigate = useNavigate();

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [editLocation, setEditLocation] = useState(false); // State to track edit mode
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);
  const [modal, setModal] = useState('');

  const [stateName, setStateName] = useState('');
  const [stateId, setStateId] = useState(0);
  const [name, setName] = useState('');
  const [scanVal, setScanVal] = useState(0);

  const [cityName, setCityName] = useState('');
  const [cityId, setCityId] = useState(0);

  const [pincode, setPincode] = useState('');
  const [resultPincode, setResultPincode] = useState(false);
  const [pincodeError, setPincodeError] = useState('');
  const [userTypeId, setUserTypeId] = useState(0);
  const [loader, setLoader] = useState(false);
  const [invalidCoupon, setInvalidCoupon] = useState(false);
  const { data, setData } = useContext(DataContext);
  const newData = { ...data };
  const [termsModal, setTermsModal] = useState(false);

  const [userDetails, setUserDetails] = useState({});
  const [termsData, setTermsData] = useState('');

  const mobileNum = newData.mobileNumber;
  const token = newData.token;
  const [stateNameNew, setStateNameNew] = useState('');
  const [cityNameNew, setCityNameNew] = useState('');






  useEffect(() => {
    init();
    if (newData.couponShow === null)
      if (newData.couponCheck === false) {
        if (newData.couponCheckCode === 2) {
          setModal(newData.couponCheckMsg);
          setIsModalWarning(true);
          newData.couponShow = true;
        }
        else if (newData.couponCheckCode === 1) {
          setInvalidCoupon(true);
          setModal(newData.couponCheckMsg);
          setIsModalWarning(true);
          newData.couponShow = true;
        }
      }
      else {
        if (newData.couponCheckCode === 0) {
          if (newData.couponCheckMsg != '') {
            setModal(newData.couponCheckMsg);
            setIsModalWarning(true);
            newData.couponShow = true;
          }
        }
      }
    newData.transactionStatus = false;
    setData(newData);
    if (token === null) {
      navigate('/')
    }
    else {
      window.history.replaceState({}, document.title, '/dashboard');
    }

  }, []);

  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);
    }
    else if (type === 2) {
      setIsModalError(false);

    }
    else if (type === 3) {
      setIsModalWarning(false);
      if (invalidCoupon) {
        navigate('/');
      }
    }
    else if (type === 5) {
      setTermsModal(false);
    }
  }
  const handleChangePincode = (event) => {
    const cleanedPin = event.target.value.replace(/\D/g, '');
    setPincode(cleanedPin);

    const pattern = regex.pinRegex;
    const isValid = pattern.test(cleanedPin);
    setResultPincode(isValid);

    if (!isValid) {
      setPincodeError("Please enter valid PIN code");
      return;
    }

    if (cleanedPin.length === 6) {
      getPincodeCheck(cleanedPin)
        .then((data) => {
          console.log('pin', data[0]);
          if (data[0].PostOffice === null) {
            setResultPincode(false);
          } else {
            const state = data[0].PostOffice[0].State;
            const city = data[0].PostOffice[0].District;

            setResultPincode(true);
            setStateNameNew(state);
            setCityNameNew(city);
          }
        })
        .catch((err) => {
          console.error("Pincode check failed", err);
        });
    }
  };

  const init = () => {

    setLoader(true);
    getUserDetail(mobileNum, newData.couponCode, newData.token)
      .then((data) => {
        setUserDetails(data.data);
        setName(data.data.name);
        setPincode(data.data.pinCode);
        setScanVal(data.data.scanVal);
        newData.scanVal = data.data.scanVal;
        newData.userDetailsBankMsg = data.data.bnkAccntMsg;
        newData.userDetailsUpiMsg = data.data.upiIdMsg;
        setData(newData);
        setStateName(data.data.stateName);
        setCityName(data.data.cityName);
        setCityId(data.data.cityId);
        setStateId(data.data.stateId);
        setUserTypeId(data.data.userTypeId);
        setResultPincode(true);

        let stateId = data.data.stateId;

        getState({ mobileNum, locationType: 'state', parentStateId: +stateId })
          .then((data) => {
            setStateList(data.data.objectDetails);
            getCity({
              mobileNo: mobileNum,
              locationType: 'city',
              parentStateId: stateId,
            })
              .then((data) => {
                setCityList(data.data.objectDetails);
                getUserType({
                  mobileNo: +mobileNum,
                  locationType: 'user_type',
                  parentStateId: '0',
                })
                  .then((data) => {
                    setLoader(false);
                    setUserTypeList(data.data.objectDetails);
                  })
                  .catch((error) => {
                  });
              })
              .catch((error) => {
                setLoader(false);

              });
          })
          .catch((error) => {
            setLoader(false);

          });

      })
      .catch((error) => {
        setLoader(false);

      });





  };
  const onStateChange = (event) => {
    setLoader(true);
    setStateName(event.target.value);
    let selected = stateList.findIndex(
      (element) => element.objectName === event.target.value
    );
    setStateId(stateList[selected].objectID);
    getCity({
      mobileNo: mobileNum,
      locationType: 'city',
      parentStateId: stateList[selected].objectID
    })
      .then((data) => {
        setLoader(false);
        setCityList(data.data.objectDetails);
      })
      .catch((error) => {
      });
  };

  const onCityChange = (event) => {
    setCityName(event.target.value);
    let selected = cityList.findIndex(
      (element) => element.objectName === event.target.value
    );
    setCityId(cityList[selected].objectID);

  };
  const openTerms = () => {
    setLoader(true);
    getTermsConditions(mobileNum, newData.tokenData)
      .then((data) => {
        setLoader(false);
        setTermsModal(true);
        setTermsData(data.data.desc);
      })
      .catch((error) => {
      });

  }
  const onSubmit = async (values) => {

    if (!editLocation) {
      setLoader(true);
      checkRedeemValue({ mobileNo: mobileNum, couponVal: scanVal }, newData.token
      )
        .then((data) => {
          if (data.statusMsg.code === 0) {
            setLoader(false);
            getPaymentMode({
              mobileNo: mobileNum
            }, newData.token)
              .then((data) => {
                newData.paymentModes = data.data.listPaymentMode;
                setData(newData);
                setLoader(false);
                navigate('/paymentMethod');

              })
              .catch((error) => { });
          } else if (data.statusMsg.code === 1) {
            setLoader(false);
            setModal(data.statusMsg.msg);
            setIsModalWarning(true);
          } else if (data.statusMsg.code === -1) {
            setLoader(false);
            setModal(data.statusMsg.msg);
            setIsModalError(true);
          }
        })
        .catch((error) => {
          setLoader(false);

        });
    } else {
      if (stateName !== stateNameNew) {
        setModal('The entered PIN code does not match the selected state. Kindly verify and update the details accordingly');
        setIsModalError(true);
        return;
      }
      setLoader(true);
      saveUserData({
        mobileNo: mobileNum,
        name: name,
        stateId: stateId,
        cityId: cityId,
        pincode: pincode,
        saveType: userDetails?.usrAccStatus,
        userType: userTypeId,
      }, newData.token)
        .then((data) => {

          if (data.statusMsg.code === 0) {
            setLoader(false);
            setModal(data.statusMsg.msg);
            setIsModalSuccess(true);
            init();
            setEditLocation(false);
          } else if (data.statusMsg.code === 1) {
            setLoader(false);
            setModal(data.statusMsg.msg);
            setIsModalWarning(true);
          } else if (data.statusMsg.code === -1) {
            setLoader(false);
            setModal(data.statusMsg.msg);
            setIsModalError(true);
          }
        })
        .catch((error) => {
          setLoader(false);

        });
    }
  };
  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />

      <div className='content-wrapper responsive-wrapper mb-4'>

        <div className='row'>
          <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
            <section className='Dashboard'>
              <div className='col-lg-12 col-md-12 col-sm-12 mb-3'>
                <div className=''>
                  {newData.scanVal && newData.scanVal !== 0 ? (
                    <p className='DarkPanel'>
                      You have won <span>₹{userDetails?.scanVal}</span>
                    </p>
                  ) : (
                    <p className='DarkPanelNormal'>
                      {' '}
                      Buy a Genuine JCB Superior Product and scan QR to win exciting cash coupons!!!
                    </p>
                  )}
                </div>
              </div>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <div className='coupon-panel text-start'>
                  <h4>Coupon Redemption Details</h4>
                  <div className='row'>
                    <div className='col'>
                      <h6>Total Redemption</h6>
                      <h3>{'₹' + userDetails ? userDetails.totalRedemption : '0'}</h3>
                      {/* <div className='chart-panel' >
                              <GaugeChart id="gauge-chart1" animate={false} hideText={true} colors={['#f78f3a']} percent={userDetails.totalRedemption / userDetails.maxRedmptnVal} />
                              <h6 style={{ alignSelf: 'center' }}><b>{`${'₹' + userDetails.totalRedemption + ' / ' + '₹' + userDetails.maxRedmptnVal}`}</b></h6>
                            </div> */}
                      <div className='mt-1 link'>
                        <a className='' onClick={() => navigate('/transactionHistory')}>
                          See Details
                        </a>
                      </div>
                    </div>
                    <div className='col pt-4'>
                      <div className='text-end badge'>
                        <Badge />
                      </div>
                      <p className='fincial'>{userDetails.fy}</p>

                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className='FormPanel pt-2'>
              <h3>User Details</h3>
              <form>
                <div className='row'>
                  <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                    <input
                      id='mobileNumber'
                      name='mobileNumber'
                      type='text'
                      value={mobileNum}
                      className='form-control'
                      placeholder='Please Enter Mobile Number'
                      disabled
                    />
                  </div>
                  <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                    <input
                      id='name'
                      name='name'
                      type='text'
                      className='form-control'
                      placeholder='Please Enter Name'
                      value={name}
                      disabled
                    />
                  </div>
                  <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                    <select
                      className='form-select form-select-lg mb-2'
                      aria-label='.form-select-lg example'
                      id='user_type'
                      name='user_type'
                      disabled
                      value={userTypeId}
                    >
                      <option >{userDetails?.userType}</option>
                      {userTypeList?.map((field, i) => (
                        <option value={field?.id} key={i}>
                          {field?.objectName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='row'>
                    <div className='col-12 ps-4 pt-3'>
                      <div className='form-check text-start mx-3'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='editLocation'
                          checked={editLocation}
                          onChange={() => setEditLocation(!editLocation)}
                        />
                        <label className='form-check-label'>
                          Edit Location
                        </label>
                      </div>
                    </div>
                    <div className='col-6'></div>
                  </div>

                  <div className='col-lg-12 col-md-12 col-sm-12 mt-n10'>
                    <div className='whitePanel mb-2'>
                      <div className='row'>
                        <div className='col-sm-12 mb-2'>
                          <select
                            className='form-select form-select'
                            aria-label='.form-select example'
                            id='state'
                            name='state'
                            disabled={!editLocation}
                            onChange={(e) => { onStateChange(e) }}
                            value={stateName}
                          >
                            <option hidden>
                              Select State
                            </option>
                            {stateList?.map((field, i) => (
                              <option value={field?.objectName} key={i}>
                                {field?.objectName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12 mb-2'>
                          <select
                            className='form-select form-select'
                            aria-label='.form-select example'
                            id='city'
                            name='city'
                            disabled={cityList.length === 0 || !editLocation}
                            onChange={(e) => { onCityChange(e) }}
                            value={cityName}
                          >
                            <option hidden>
                              Select City
                            </option>
                            {cityList?.map((field, i) => (
                              <option value={field?.objectName} key={i}>
                                {field?.objectName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className=''>
                          <div className='col-lg-12 col-md-12 col-sm-12'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Enter Pincode'
                              id='pinCode'
                              name='pinCode'
                              maxLength={6}
                              inputMode="numeric"
                              disabled={!editLocation}
                              value={pincode}
                              onChange={(event) => handleChangePincode(event)}
                            />
                            {!resultPincode ? (
                              <div className='error text-danger text-start'>
                                {pincodeError}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className='terms text-center pt-1'>
                  <p>
                    <a onClick={openTerms}><u>Terms & Conditions</u></a>
                  </p>
                  {/* {!terms ? (
                      <div className='error text-start'>
                        Terms & Conditions must be accepted
                      </div>
                    ) : null} */}
                </div>
                <div className='row mt-1'>
                  <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                    {!editLocation ? <button
                      type='button'
                      className='btn btn-primary'
                      onClick={onSubmit}
                      disabled={
                        !scanVal ||
                        newData.scanVal === 0
                        || newData.couponCheckCode !== 0
                      }
                    >
                      Redeem
                    </button> :
                      <button
                        type='button'
                        className='btn btn-primary'
                        onClick={onSubmit}
                        disabled={stateId === 0 || cityId === 0 || !resultPincode || cityList.length === 0}
                      >
                        Submit
                      </button>}
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>

      <Modal show={termsModal} keyboard={false} onHide={() => handleClose(5)}>
        <Modal.Header>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: termsData }}>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose(5)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalSuccess} onHide={() => handleClose(1)} >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(1)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalError} onHide={() => handleClose(2)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(2)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal >
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarning} onHide={() => handleClose(3)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}
    </>
  );
};

export default Dashboard;
